import styled, { css } from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "Ratingsstyles__Wrapper",
  componentId: "pi51c-0"
})(["display:flex;align-items:center;align-self:flex-start;justify-content:center;", " ", " ", " ", ""], function (props) {
  return css(["font-family:", ";font-size:", ";"], props.theme.font.family.brand, props.theme.font.size.base);
}, function (props) {
  return props.position === 'left' && css(["justify-content:flex-start;"]);
}, function (props) {
  return props.position === 'spaceBetween' && css(["justify-content:space-between;"]);
}, function (props) {
  return props.position === 'right' && css(["justify-content:flex-end;"]);
});
var Count = styled.span.withConfig({
  displayName: "Ratingsstyles__Count",
  componentId: "pi51c-1"
})(["margin-left:5px;align-items:center;display:flex;"]);
var Stars = styled.div.withConfig({
  displayName: "Ratingsstyles__Stars",
  componentId: "pi51c-2"
})(["display:inline-block;position:relative;", ""], function (props) {
  return props.interactive && css(["cursor:pointer;"]);
});
var EmptyStars = styled.div.withConfig({
  displayName: "Ratingsstyles__EmptyStars",
  componentId: "pi51c-3"
})(["white-space:nowrap;"]);
var FilledStars = styled.div.withConfig({
  displayName: "Ratingsstyles__FilledStars",
  componentId: "pi51c-4"
})(["white-space:nowrap;overflow:hidden;position:absolute;top:0;left:0;"]);
var Label = styled.label.withConfig({
  displayName: "Ratingsstyles__Label",
  componentId: "pi51c-5"
})(["display:inline-block;cursor:pointer;"]);
var RadioInput = styled.input.attrs({
  type: 'radio'
}).withConfig({
  displayName: "Ratingsstyles__RadioInput",
  componentId: "pi51c-6"
})(["&:focus + label,&:active + label{outline:1px auto Highlight;outline:1px auto -webkit-focus-ring-color;}"]);
export { Wrapper, Count, Stars, EmptyStars, FilledStars, Label, RadioInput };